"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const common_buoy_input_1 = require("@buoyhealth/common.buoy-input");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const common_buoy_layout_1 = require("@buoyhealth/common.buoy-layout");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const styles_1 = require("./styles");
const FeedbackCopy_1 = __importDefault(require("../../../../common/FeedbackCopy"));
const HelpfulnessSurveyForm = ({ canCollectUserEmail, onChange, answers, setFocus, control, multipleChoice, }) => {
    const [value, setValue] = (0, react_1.useState)();
    const options = (0, react_1.useMemo)(() => answers.map((answer) => ({
        value: answer.label,
        label: answer.showLabel ? answer.label : "",
    })), [answers]);
    const bestAnswer = (0, react_1.useMemo)(() => (answers.find((a) => a.bestAnswer) || answers[answers.length - 1]).label, [answers]);
    const handleChange = (event) => {
        const val = event.target.value;
        setValue(val);
        onChange(val, val === bestAnswer);
    };
    const shouldShowTextInput = (0, react_1.useMemo)(() => !!value, [value]);
    const shouldShowEmailInput = (0, react_1.useMemo)(() => !!value && canCollectUserEmail, [canCollectUserEmail, value]);
    (0, react_1.useEffect)(() => {
        if (!multipleChoice && (shouldShowTextInput || value)) {
            // If there are no multiple choice options, automatically focus the next input to help encourage input.
            // We need the timeout here to wait for the Collapse animation to finish.
            setTimeout(() => {
                if (shouldShowTextInput) {
                    setFocus("freeText");
                }
                else if (shouldShowEmailInput) {
                    setFocus("email");
                }
            }, 300);
        }
    }, [
        multipleChoice,
        setFocus,
        shouldShowEmailInput,
        shouldShowTextInput,
        value,
    ]);
    const subOptimalAnswerChosen = value !== bestAnswer;
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledForm, { children: [(0, jsx_runtime_1.jsx)(styles_1.RadioWrapper, { "data-testid": "radio-numeric-scale", children: (0, jsx_runtime_1.jsx)(common_buoy_input_1.RadioGroup, { iconSize: 24, labelPlacement: "bottom", onChange: handleChange, options: options, row: true }) }), (0, jsx_runtime_1.jsxs)(common_buoy_layout_1.CollapseAndFade, { show: shouldShowTextInput, children: [(0, jsx_runtime_1.jsx)(styles_1.Paragraph, { children: subOptimalAnswerChosen
                            ? FeedbackCopy_1.default.HelpUsImprove
                            : FeedbackCopy_1.default.Great }), subOptimalAnswerChosen && multipleChoice && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { sx: { margin: "5px 0 10px" }, variant: "body2", children: FeedbackCopy_1.default.SelectAll }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: "multipleChoice", render: ({ field }) => {
                                    const { ref: inputRef, ...fieldProps } = field;
                                    return ((0, jsx_runtime_1.jsx)(common_buoy_input_1.ToggleButtonGroup, { ...fieldProps, multiSelect: true, onChange: (_event, val) => fieldProps.onChange(val), options: multipleChoice }));
                                } })] })), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: "freeText", render: ({ field }) => {
                            const { ref: inputRef, ...fieldProps } = field;
                            return ((0, jsx_runtime_1.jsxs)(styles_1.TextAreaContainer, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledTextArea, { ...fieldProps, "data-testid": "text-field", fullWidth: true, inputProps: { maxLength: 190 }, inputRef: inputRef, placeholder: multipleChoice && subOptimalAnswerChosen
                                            ? FeedbackCopy_1.default.AnythingElse
                                            : "", rows: 2 }), (0, jsx_runtime_1.jsxs)(styles_1.CharacterCount, { children: [fieldProps.value?.length, "/190"] })] }));
                        } })] }), (0, jsx_runtime_1.jsxs)(common_buoy_layout_1.CollapseAndFade, { show: !!value, children: [!shouldShowTextInput && shouldShowEmailInput && ((0, jsx_runtime_1.jsx)(styles_1.Paragraph, { children: FeedbackCopy_1.default.FollowUp })), shouldShowEmailInput && ((0, jsx_runtime_1.jsx)(common_buoy_input_1.Email
                    // @ts-expect-error: throws because email is not the only field in this form
                    , { 
                        // @ts-expect-error: throws because email is not the only field in this form
                        control: control, label: "", placeholder: "Email address (optional)", required: false }))] })] }));
};
exports.default = HelpfulnessSurveyForm;
//# sourceMappingURL=index.js.map